/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-dialog.cascading-modal.modal-avatar[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:130px;margin-left:auto;margin-right:auto}.modal-dialog.cascading-modal.modal-avatar[_ngcontent-%COMP%]   .modal-header[_ngcontent-%COMP%]{margin:-6rem 2rem -1rem}"];
export { styles as styles };
